<template>
  <div class="mt-2">
    <div 
      v-for="[pointId, point] in sortedPoints" 
      :key="pointId"
      class="w-full overflow-hidden cursor-pointer"
      @click="handleItemClick(point, false)"
    >
      <ListItemTemplate
        :icon="point?.data?.icon?.preview_url"
        :image="point?.data?.image?.preview_url"
        :title="showMultiLingualText(point.data.title, null, true)"
        :description="showMultiLingualText(point.data.description, null, true)"
        :isGPSLocked="isPointGPSLocked(pointId)"
      />
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { mapGetters } from 'vuex'
import ListItemTemplate from './ListItemTemplate.vue'
import { showMultiLingualText } from '../utils/languageUtils'

export default {
  name: 'VueList',
  components: {
    ListItemTemplate
  },
  props: {
    currentLocation: {
      type: Object,
      default: null
    },
    points: {
      type: Object,
      required: true
    },
    onItemClick: {
      type: Function,
      required: true
    },
    isPointGPSLocked: {
      type: Function,
      default: () => false
    }
  },
  computed: {
    ...mapGetters('settings', ['tourSettings']),
    
    // Sort points by order, similar to React implementation
    sortedPoints() {
      return Object.entries(this.points).sort(([, a], [, b]) => a.data.order - b.data.order)
    }
  },
  mounted() {
    // Track page view (mirrors React implementation)
    if (window._paq) {
      window._paq.push(['setCustomUrl', window.location.pathname])
      window._paq.push(['setDocumentTitle', 'Points - List'])
      window._paq.push(['trackPageView'])
    }
  },
  methods: {
    showMultiLingualText(text, altText = null, showFirstLanguage = false) {
      return showMultiLingualText(text, altText, showFirstLanguage, this.$i18n.locale)
    },
    
    handleItemClick(point, showPreview = false) {
      this.onItemClick(point, showPreview)
    }
  }
}
</script>

<style scoped>
/* Add any additional styles if needed */
</style> 